import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getPathAlias, getVehicleForBrand } from 'tw-oi-core/utils/vehicle'
import * as VehicleActions from 'tw-oi-core/actions/VehicleActions'

import { ROUTE, BRANDS, MESSAGE } from '../config'
import Loader from '../components/Loader'
import ErrorMessage from '../components/ErrorMessage'

class VehicleRedirect extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    vehicle: PropTypes.shape({
      vehicles: PropTypes.array,
      currentBrand: PropTypes.string,
      error: PropTypes.object,
    }).isRequired,
    VehicleActions: PropTypes.shape({
      getVehicles: PropTypes.func.isRequired,
    }).isRequired,
  }

  componentDidMount() {
    const { vehicles } = this.props.vehicle
    if (vehicles === null) {
      this.props.VehicleActions.getVehicles()
    }
  }

  render() {
    const { match: { params: { id } }, vehicle: { vehicles, currentBrand, error } } = this.props

    if (error) {
      return <ErrorMessage className="inverse" retryAction={() => this.props.VehicleActions.getVehicles()} />
    }

    if (vehicles === null) {
      return <Loader className="inverse" />
    }

    const brandVehicles = getVehicleForBrand(vehicles, currentBrand)
    const targetVehicle = brandVehicles.find(v => String(v.id) === String(id))

    if (!targetVehicle) {
      const brand = BRANDS.find(b => b.name === currentBrand)
      const brandRoute = brand ? `/${brand.key}` : '/'
      return (
        <ErrorMessage
          className="inverse"
          title={MESSAGE.ERROR_VEHICLE_NOT_FOUND}
          retryAction={brandRoute + ROUTE.VEHICLES}
          retryTitle="Select vehicle"
          message={MESSAGE.ERROR_VEHICLE_RETRY}
        />
      )
    }

    const modelSlug = getPathAlias(`${targetVehicle.id} ${targetVehicle.model}`)
    const brand = BRANDS.find(b => b.name === currentBrand)
    const brandKey = brand ? brand.key : ''

    return <Redirect to={`/${brandKey}${ROUTE.GUIDE}/${targetVehicle.year}/${modelSlug}${ROUTE.BROWSE}`} />
  }
}

function mapStateToProps({ vehicle }) {
  return { vehicle }
}

function mapDispatchToProps(dispatch) {
  return {
    VehicleActions: bindActionCreators(VehicleActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleRedirect)
